import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { PanelState } from 'store/modules/panel_store/types';
import { ProfileState } from 'store/modules/profile_store/types';
import { useAmbassadorInviteBanner } from 'hooks/useAmbassadorInviteBanner';
import useOnlyConlicitaseg from 'hooks/useOnlyConlicitaseg';
import useReleaseFidelizeLoginRedirect from 'hooks/useReleaseFidelizeLoginRedirect';

import { Container } from './styles';

const DefaultLayout: React.FC = ({ children }) => {
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);
  const isOnlyConlicitaseg = useOnlyConlicitaseg();
  const showAmbassadorInvite = useAmbassadorInviteBanner();
  useReleaseFidelizeLoginRedirect();

  const hasTopBanner =
    !isOnlyConlicitaseg && (profile.in_sample || panel?.registration_type_validation === 1);

  return (
    <Container
      className={`${hasTopBanner ? 'hasTopBanner' : ''} ${
        showAmbassadorInvite ? 'hasAmbassadorBanner' : ''
      } new-menu-header`}
      id="windowDiv"
    >
      {children}
    </Container>
  );
};

export default DefaultLayout;
